// src/components/EditOrderModal.jsx
import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./EditOrderModal.css"; // Create and update this CSS file as needed

const EditOrderModal = ({ isOpen, onClose, order, onOrderUpdated }) => {
  // Local state for editable fields
  const [orderDetails, setOrderDetails] = useState({
    description: "",
    status: "Pending",
    // If you need date fields for restaurant orders, you can add them here.
    // For example, an order time or estimated completion time.
  });

  // When the modal opens, initialize local state with the order data.
  useEffect(() => {
    if (order) {
      setOrderDetails({
        description: order.description || "",
        status: order.status || "Pending",
      });
    }
  }, [order]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setOrderDetails((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    // Call the onOrderUpdated callback with the updated order details.
    onOrderUpdated(orderDetails);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Edit Order</h2>
        <p>You can update the order description or cancel the order.</p>
        <form>
          <div className="form-group">
            <label htmlFor="description">Order Description:</label>
            <input
              id="description"
              type="text"
              name="description"
              value={orderDetails.description}
              onChange={handleChange}
              placeholder="Enter updated order items"
            />
          </div>
          <div className="form-group">
            <label htmlFor="status">Order Status:</label>
            <select
              id="status"
              name="status"
              value={orderDetails.status}
              onChange={handleChange}
            >
              <option value="Pending">Pending</option>
              <option value="Processed">Processed</option>
              <option value="Cancelled">Cancelled</option>
            </select>
          </div>
          <div className="modal-buttons">
            <button type="button" onClick={handleSave}>
              Save Changes
            </button>
            <button type="button" onClick={onClose}>
              Close
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditOrderModal;
